// This is just to make the conversion for existing consumers of this file less work
export { buildRoutingRulesFromType } from './buildRoutingRules';